import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import ShatterScene from './ShatterScene';
import R3FErrorBoundary from './R3FErrorBoundary';

/**
 * R3FStage — full-bleed fixed canvas + scroll/mouse tracking.
 * Mounts ShatterScene; pages drive progress via the parent's scroll listener.
 */
export default function R3FStage({ progressRef, mouseRef }) {
  // Dereference the wrapper ref once — `mouse.x.current` / `mouse.y.current` is what the scene expects.
  const mouse = mouseRef.current;
  return (
    <div className="fixed inset-0 w-full h-full pointer-events-none z-0" data-testid="r3f-stage">
      <R3FErrorBoundary>
        <Canvas
          gl={{ antialias: true, alpha: false, powerPreference: 'high-performance' }}
          dpr={[1, 2]}
          camera={{ position: [0, 0, 14], fov: 42, near: 0.1, far: 80 }}
          style={{ background: '#0A0A0F' }}
        >
          <Suspense fallback={null}>
            <ShatterScene progress={progressRef} mouse={mouse} />
          </Suspense>
        </Canvas>
      </R3FErrorBoundary>
    </div>
  );
}
